import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import About from "../../components/about/about";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/Navbar/Navbar";

const trustLinks = [
  {
    to: "/why-choose-us",
    title: "Why Choose Us",
    desc: "UAE registered, PCI-compliant, anti-fraud, fast delivery, real support.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M12 2L2 7v7c0 5.55 3.84 10.74 10 12 6.16-1.26 10-6.45 10-12V7z" />
      </svg>
    ),
  },
  {
    to: "/corporate-orders",
    title: "Corporate Orders",
    desc: "Employee rewards, bulk gift cards, promotions and incentive programs.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M20 6h-4V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H4a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2zM10 4h4v2h-4z" />
      </svg>
    ),
  },
  {
    to: "/supplier-standards",
    title: "Supplier Standards",
    desc: "Sourced only through authorized, vetted distribution channels — every code traceable.",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
    ),
  },
];

const AboutTrustLinks = () => (
  <section className="apl-section">
    <div className="apl-bg-orb apl-bg-orb-tl" />
    <div className="apl-bg-orb apl-bg-orb-br" />
    <div className="apl-inner">
      <div className="apl-head">
        <div className="apl-eyebrow">
          <span className="apl-eyebrow-dot" />
          DIG DEEPER
        </div>
        <h2 className="apl-title">
          Explore how we{" "}
          <span className="apl-title-accent">operate</span>
        </h2>
        <p className="apl-sub">
          From who we are to how we source — explore the details behind every
          order.
        </p>
      </div>

      <div className="apl-grid">
        {trustLinks.map((t, i) => (
          <Link key={i} to={t.to} className="apl-card">
            <div className="apl-card-glow" aria-hidden="true" />
            <div className="apl-icon">{t.icon}</div>
            <h3>{t.title}</h3>
            <p>{t.desc}</p>
            <span className="apl-arrow">
              Read more
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </span>
          </Link>
        ))}
      </div>
    </div>

    <style>{`
      .apl-section {
        position: relative;
        background: linear-gradient(180deg, #07060a 0%, #0b0b0c 100%);
        padding: 70px 22px 80px;
        overflow: hidden;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        color: #e6e8ec;
        border-top: 1px solid rgba(212, 168, 87, 0.08);
      }
      .apl-bg-orb {
        position: absolute;
        width: 380px;
        height: 380px;
        border-radius: 50%;
        filter: blur(120px);
        pointer-events: none;
        opacity: 0.45;
      }
      .apl-bg-orb-tl {
        background: rgba(212, 168, 87, 0.18);
        top: -140px;
        left: -100px;
      }
      .apl-bg-orb-br {
        background: rgba(212, 168, 87, 0.12);
        bottom: -160px;
        right: -100px;
      }

      .apl-inner { position: relative; max-width: 1200px; margin: 0 auto; z-index: 1; }
      .apl-head { text-align: center; margin-bottom: 40px; }
      .apl-eyebrow {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 6px 14px;
        background: rgba(212, 168, 87, 0.1);
        border: 1px solid rgba(212, 168, 87, 0.3);
        color: #d4a857;
        border-radius: 999px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 2px;
        margin-bottom: 14px;
      }
      .apl-eyebrow-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #d4a857;
        box-shadow: 0 0 10px #d4a857;
        animation: apl-pulse 1.6s ease-in-out infinite;
      }
      @keyframes apl-pulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.55; transform: scale(0.85); }
      }
      .apl-title {
        font-family: "Playfair Display", "Times New Roman", serif;
        font-size: 32px;
        color: #fff;
        font-weight: 700;
        margin: 0 0 10px;
        line-height: 1.2;
      }
      .apl-title-accent {
        background: linear-gradient(135deg, #f1cf85, #b58a3f);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-style: italic;
        font-weight: 600;
      }
      .apl-sub { font-size: 14px; color: #9aa0a8; max-width: 600px; margin: 0 auto; line-height: 1.6; }

      .apl-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 18px;
      }
      .apl-card {
        position: relative;
        display: block;
        background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
        border: 1px solid rgba(212, 168, 87, 0.2);
        border-radius: 16px;
        padding: 26px 22px;
        text-decoration: none;
        color: inherit;
        overflow: hidden;
        transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;
      }
      .apl-card:hover {
        transform: translateY(-4px);
        border-color: rgba(212, 168, 87, 0.55);
        box-shadow: 0 16px 36px rgba(212, 168, 87, 0.14), 0 6px 14px rgba(0, 0, 0, 0.4);
        text-decoration: none;
        color: inherit;
      }
      .apl-card-glow {
        position: absolute;
        top: -60px;
        right: -60px;
        width: 160px;
        height: 160px;
        background: radial-gradient(circle, rgba(212, 168, 87, 0.18), transparent 70%);
        opacity: 0;
        transition: opacity .3s ease;
        pointer-events: none;
      }
      .apl-card:hover .apl-card-glow { opacity: 1; }
      .apl-icon {
        width: 46px;
        height: 46px;
        background: rgba(212, 168, 87, 0.12);
        color: #d4a857;
        border: 1px solid rgba(212, 168, 87, 0.25);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
      }
      .apl-card h3 {
        font-family: "Playfair Display", "Times New Roman", serif;
        font-size: 19px;
        color: #fff;
        margin: 0 0 8px;
        font-weight: 700;
        letter-spacing: -0.2px;
      }
      .apl-card p { font-size: 13.5px; color: #9aa0a8; line-height: 1.55; margin: 0 0 16px; }
      .apl-arrow {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: #d4a857;
        font-size: 12.5px;
        font-weight: 700;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        transition: gap .25s ease;
      }
      .apl-card:hover .apl-arrow { color: #f1cf85; gap: 10px; }

      @media (max-width: 991px) {
        .apl-grid { grid-template-columns: 1fr; gap: 14px; }
        .apl-title { font-size: 24px; }
      }
      @media (max-width: 640px) {
        .apl-section { padding: 50px 16px 60px; }
        .apl-title { font-size: 22px; }
      }
    `}</style>
  </section>
);

const AboutPage = () => {
  return (
    <Fragment>
      <Navbar />
      <About />
      <AboutTrustLinks />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default AboutPage;
